import React, {Component} from 'react';
import {
    AppBar,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    TextField,
    Toolbar,
    Typography,
} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles/index';
import {bindActionCreators} from 'redux';
import ReduxGlobal from "../../../../store/actionreducers/globalView";
import ReduxGroup from '../../../../store/actionreducers/group';
import ReduxVip from '../../../../store/actionreducers/vip';
import {connect} from 'react-redux';
import _ from 'lodash';
import {constDataDialogs} from "../../../../constants";
import ReduxUseRecord from "../../../../store/actionreducers/useRecord";

const styles = theme => ({
    root: {},
    button: {
        margin: theme.spacing.unit,
    },
    formControl: {
        marginBottom: 24
    },
});

const initNewVipState = {
    user: {
        avatar: {url: 'https://res.cloudinary.com/uecare/image/upload/v1524205226/DefaultImage/vipHead_3x.png'},
    },
};

const initControllerState = {
    pricePlan:{id:0,name:'請選擇',annual_fee:'請選擇'}
};

/*const plan_prop = [
    // {id:1,name:'企業會員方案',annual_fee:'5千'},// 個人會員無法變成企業會員
    {id:2,name:'個人方案',annual_fee:'1萬'},
    {id:3,name:'個人高用量會員方案',annual_fee:'5萬'},
    {id:4,name:'家庭頂客會員方案',annual_fee:'10萬'},
    {id:5,name:'大家庭會員方案',annual_fee:'20萬'},
    {id:6,name:'達康會員方案', annual_fee: '1萬'},
    {id:7,name:'境內防疫方案', annual_fee: '0元'},
    {id:8,name:'境外防疫方案', annual_fee: '0元'},
];*/

class AddPointDialog extends Component {

    _onPointChange = e => {
        this.setState({ point: e.target.value });
    }

    constructor(props) {
        super(props);

        this.state = {vip: initNewVipState, point: '2000', ...initControllerState};
    }

    componentDidUpdate(prevProps, prevState, snapshot) {

        /**
         * no useRecordDialog , no data need to resolve
         */
        if (!this.props.addPointDialog) return;

        /**
         * After Dialog Open
         */
        if (!prevProps.addPointDialog || (!prevProps.addPointDialog.props.open && this.props.addPointDialog.props.open)) {
            if (this.props.vip && !_.isEqual(this.props.vip, prevState.vip)) {

                // // 有些 groupType 在列表之外
                // const propGroupType = this.props.groupTypes.find((groupType) => {
                //     return groupType.label === this.props.vip.group.type.label;
                // });
                //
                // this.setState({
                //     vip: this.props.vip, ...initControllerState,
                //     groupType: propGroupType || this.props.personGroupType
                // });
            }
        }
    }


    closeDataDialog = () => {
        this.props.closeDataDialog({name: constDataDialogs.name.addPointDialog});
    };

    addPoint = async () => {
        const { openLoadingMask, closeLoadingMask, vip} = this.props;
        try {
            openLoadingMask();
            await this.props.addGroupCurrentPoint({ groupId: vip ? vip.group.id : 0, point: this.state.point });
            await this.props.getUseRecordsByUserId(vip ? vip.user.id : 0);
            await this.props.getVip(vip ? vip.id : 0);
            closeLoadingMask();
            this.closeDataDialog();
        } catch (e) {
            console.warn('you got an error = ', e);
        }
    };

    render() {
        const {classes, addPointDialog} = this.props;


        if (!addPointDialog || addPointDialog.props.open === false) return <div/>;


        return (
            <Dialog className={classes.root} {...addPointDialog.props} onClose={this.closeDataDialog} fullWidth
                    maxWidth="xs">

                <AppBar position="static">
                    <Toolbar className="flex w-full">
                        <Typography variant="subheading" color="inherit">
                            加值點數
                        </Typography>
                    </Toolbar>
                    <div className="flex flex-col items-center justify-center pb-24">
                        <Typography variant="title" color="inherit" className="pt-8">
                            {this.state.vip.user.name}
                        </Typography>
                    </div>
                </AppBar>

                <DialogContent classes={{root: "p-24"}}>

                    <form onSubmit={this.addPoint}>
                        <TextField
                            label="請輸入欲加點之點數"
                            type="number"
                            value={this.state.point}
                            onChange={this._onPointChange}
                        />
                    </form>

                </DialogContent>

                <DialogActions className="justify-between pl-16">
                    <Button
                        variant="raised"
                        color="primary"
                        onClick={this.addPoint}
                    >
                        確認送出
                    </Button>
                </DialogActions>

            </Dialog>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getVip: ReduxVip.ActionCreator.getVip,
        addGroupCurrentPoint: ReduxGroup.ActionCreator.addGroupCurrentPoint,
        getUseRecordsByUserId: ReduxUseRecord.ActionCreator.getUseRecordsByUserId,
        closeDataDialog: ReduxGlobal.ActionCreator.closeDataDialog,
        openLoadingMask: ReduxGlobal.ActionCreator.openLoadingMask,
        closeLoadingMask: ReduxGlobal.ActionCreator.closeLoadingMask,
    }, dispatch);
}

function mapStateToProps({global: {dataDialogs}, group: {groups}, company: {companies}, vip: {vip}, missionPriceType, groupType}) {

    const personGroupType = groupType.list.find((groupType) => {
        return groupType.label === 'person';
    });

    return {
        groups,
        companies,
        vip,
        addPointDialog: dataDialogs[constDataDialogs.name.addPointDialog],
        missionPriceTypes: missionPriceType.list,
        groupTypes: groupType.list,
        personGroupType
    }
}


export default withStyles(styles, {withTheme: true})(connect(mapStateToProps, mapDispatchToProps)(AddPointDialog));



// WEBPACK FOOTER //
// ./src/main/content/callHelper/useRecord/AddPointDialog.js